export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(date.getDate() + days);
  return result;
};

export const extractDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(date.getDate() - days);
  return result;
};

export const getDateStart = (date: Date): Date => new Date(date.setHours(0, 0, 0, 0));
export const getDateEnd = (date: Date): Date => new Date(date.setHours(24, 0, 0, 0) - 1);
